function SleepApneaCalc(gender, age, imc, sistolic, neck, YNs) {

    let high_sis = parseInt(sistolic) >= 130 ? 1 : 0

    let high_neck = (gender === "M" && neck >= 43) || (gender === "F" && neck >= 41) ? 1 : 0

    let gender_m = gender === "M" ? 1 : 0

    let old = age > 50 ? 1 : 0

    let obesity = imc > 35 ? 1 : 0

    let first_four = [high_sis,...YNs]
    let all_ans = [high_sis,...YNs,high_neck,old,obesity,gender_m]

    let results = {}

    if((first_four.reduce((partialSum, a) => partialSum + a, 0) >= 2 && (gender === "M" || imc > 35)) || all_ans.reduce((partialSum, a) => partialSum + a, 0) >= 5) {
        results["risk_cat"] = "Alto"
        results["risk"] = 2
    } else if(all_ans.reduce((partialSum, a) => partialSum + a, 0) >= 3) {
        results["risk_cat"] = "Moderado"
        results["risk"] = 1
    } else {
        results["risk_cat"] = "Bajo"
        results["risk"] = 0
    }

    results["points"] = all_ans.reduce((partialSum, a) => partialSum + a, 0)

    return results;
};

export default SleepApneaCalc;